import type { Color } from '../types';

type Props = {
  from: string;
  to: string;
  color: Color;
  onSelect: (piece: 'q' | 'r' | 'b' | 'n') => void;
  onCancel: () => void;
};

const options = [
  ['q', 'Ферзь'],
  ['r', 'Ладья'],
  ['b', 'Слон'],
  ['n', 'Конь']
] as const;

export function PromotionModal({ onSelect, onCancel }: Props) {
  return (
    <div className="promotion-overlay">
      <div className="promotion-modal">
        <h2>Превращение пешки</h2>
        <div className="promotion-actions">
          {options.map(([piece, label]) => (
            <button
              key={piece}
              className="promotion-choice"
              onClick={() => onSelect(piece)}
            >
              {label}
            </button>
          ))}
        </div>
        <button className="ghost full" onClick={onCancel}>Отмена</button>
      </div>
    </div>
  );
}